import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import type { ExperimentMetrics } from "../experiments/experimentClient";
import { buildOverviewTiles } from "./monetizationModel";

export function MonetizationOverview({
  metrics,
}: {
  metrics: ExperimentMetrics;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {buildOverviewTiles(metrics).map((tile) => (
        <Card key={tile.label}>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {tile.label}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-semibold tabular-nums">{tile.value}</p>
            {tile.hint ? (
              <p className="mt-1 text-xs text-muted-foreground">{tile.hint}</p>
            ) : null}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
